import api from "./apiUrl";
import { authHeader, encodedURL } from "../_helpers/auth-header";

export function updateChangePassword(oldPassword, newPassword) {
  var urlparam = "&oldPassword=" + oldPassword;
  urlparam += "&newPassword=" + newPassword;

  return fetch(
    `${api.proxyUrl}${api.url}${encodedURL(
      `/changepassword/updateLoginPassword?identityKey=${localStorage
        .getItem("identityKey")
        .trim()}&companyNumber=${localStorage.getItem(
        "companyNumber"
      )}&customerNumber=${localStorage.getItem("customerNumber")}${urlparam}`
    )}`,
    {
      method: "GET",
      headers: authHeader(),
    }
  ).then((res) => { 
    Promise.resolve(res)

  });
}



export function updateChangePasswordNew(oldPassword, newPassword) {
  var urlparam = "&oldPassword=" + oldPassword;
  urlparam += "&newPassword=" + newPassword;

  const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              'FullUserid': localStorage .getItem("identityKey"),
              'LoginTypeCode': "",
              'CompanyNumber': "",
              'Password': "",
              'AmphirePasswordFlag': "",
              'ReturnCode': "",
              'MiscFlag':"",
              'Otp' : "",
              'OldPassword' : oldPassword,
              'NewPassword' : newPassword,
              'Url':`${api.url}/changepassword/get_update_password`
            })
      };
  
      return fetch(`${api.proxyPost}`, requestOptions)
      .then(handleResponse => handleResponse.json())
   
      .then(user => {
        
          return Promise.resolve(user);        
      });
    }
